export enum SettingName {
    DefaultHealthTechnician = 'DefaultHealthTech',
    InactivityTimeout = 'InactivityTimeout'
}
